import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Container, Row, Table } from "react-bootstrap";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../src/store/actions/authAction";
import { get_category_menu_setup } from "../../../../src/store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import BasicPagination from "../../Pagination/Pagination";
import FiltersSection from "../ItemAvailability/FiltersSection";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import TableBody from "./Categorytables/TableBody";
import { TableHead } from "./Categorytables/TableHead";
import SubNavigationItemAvailability from "./SubNavigationItemAvailability";

const CategoryDashboard = (props) => {
  const [loading, setLoading] = useState(false);
  let history = useHistory();
  const onSuccess = () => {
    setLoading(false);
  };

  const [search, setSearch] = useState("");
  const onChangeSearch = (e) => {
    setSearch(e);
  };
  const [page, setPage] = useState(1);
  // var page = 1;

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    let calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const filteredCategory =
    props &&
    props.menuCategory &&
    props.menuCategory.filter((item) => {
      return item.name.toLowerCase().includes(search);
    });

  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token, onSuccess);
  }, []);
  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [search]);
  return (
    <React.Fragment>
      {loading ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
            <Row>
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="top-panel">
                <TopNavigationBarMobile displayLeft="logo" />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation />
                <Container fluid>
                  <div className="super-admin-inside-right-side-panel">
                    <div className="seating_dashboard_top_new_header">
                      <div className="row">
                        <div className="col-6">
                          <h4>Category Dashboard</h4>
                        </div>
                        <div className="col-6 text-right">
                          <button
                            onClick={(e) => {
                              history.push("/addcategory");
                            }}
                            className="btn add_button_custom_1"
                          >
                            + Add Category
                          </button>
                        </div>
                      </div>
                    </div>
                    <SubNavigationItemAvailability />
                    <br />
                    <FiltersSection
                      search={(search) => onChangeSearch(search)}
                    />
                    <div className="col-12 p-0  user-table-reusable-superadmin ">
                      <Table>
                        <thead>
                          <TableHead />
                        </thead>
                        {filteredCategory
                          .slice(start, end)
                          .map((category, index) => (
                            <Fragment key={index}>
                              {!category.is_temp_local ? (
                                <TableBody
                                  token={props.auth.user.accessToken}
                                  category={category}
                                />
                              ) : (
                                <> </>
                              )}
                            </Fragment>
                          ))}
                      </Table>
                    </div>

                    {filteredCategory.length > 0 ? (
                      <BasicPagination
                        totalRecords={filteredCategory.length}
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <> </>
                    )}
                  </div>
                </Container>
              </div>
              <div className="bottom-panel"></div>
            </Row>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

CategoryDashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategory: state.onboarding && state.onboarding.menuCategory,
  allSubscriptionData:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .menu_setup,
});

export default connect(mapStateToProps, {
  get_category_menu_setup,
  update_new_subscription_for_vendor,
})(CategoryDashboard);
